import React from 'react';
import { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

interface IconTitleProps {
  icon: LucideIcon | React.ComponentType<{ className?: string }>;
  title: string;
  className?: string;
  iconClassName?: string;
  titleClassName?: string;
  iconWrapperClassName?: string;
}

export function IconTitle({ 
  icon: Icon, 
  title, 
  className,
  iconClassName,
  titleClassName,
  iconWrapperClassName 
}: IconTitleProps) {
  return (
    <div className={cn("flex items-center gap-1.5", className)}>
      <div className={cn(
        "flex items-center justify-center h-[18px] w-[18px] bg-gray-100 rounded p-[3px]",
        iconWrapperClassName
      )}>
        <Icon className={cn("h-[12px] w-[12px] text-primary", iconClassName)} />
      </div>
      <h2 className={cn("text-dark-blue heading-7", titleClassName)}>
        {title}
      </h2>
    </div>
  );
}